export const NAME = "manifest-search";

export const PAGE_SIZE = 40;
